enum SettleType {
  CONCILIATION = 'CONCILIATION',
  BANK_MOVEMENTS = 'BANK_MOVEMENTS',
}

export default SettleType;
